export var jsGlobal = Function('return this')();
